module.exports = __webpack_public_path__ + "img/linkedin.1a323c76.svg";